<script setup>
import NavItem from '../NavItem/index.vue'
import { Icon } from '@iconify/vue'

defineProps({ item: { type: Object, default: undefined }, level: { type: Number, default: 0 } })
</script>

<template>
  <v-list-group no-action>
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        :value="item.title"
        rounded
      >
        <template #prepend>
          <Icon
            :icon="'solar:' + item.icon"
            height="18"
            width="18"
            :level="level"
            class="dot"
            :class="'text-' + item.BgColor"
          />
        </template>
        <v-list-item-title class="mr-auto">
          {{ $t(item.title) }}
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="item.subCaption"
          class="text-caption mt-n1 hide-menu"
        >
          {{ item.subCaption }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>

    <template v-if="item.children">
      <template
        v-for="(subitem, i) in item.children"
        :key="i"
      >
        <NavCollapse
          v-if="subitem.children"
          :item="subitem"
          :level="level + 1"
        />
        <NavItem
          v-else
          :item="subitem"
          :level="level + 1"
        />
      </template>
    </template>
  </v-list-group>
</template>
